import React from 'react';
import { Check, Gem } from 'lucide-react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const AdvantagesCard = ({ advantages }) => {
  const items = advantages && advantages.length > 0 ? advantages : ['', '', '', '', ''];
  return (
    <div
      style={{
        background: COLORS.card,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.card,
        overflow: 'hidden',
        marginBottom: '6px'
      }}
    >
      <div
        style={{
          background: COLORS.primary,
          color: COLORS.card,
          padding: '8px 10px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <Gem size={16} color={COLORS.card} strokeWidth={2.5} />
        <div style={{ flex: 1 }}>
          <div style={{ ...TYPOGRAPHY.sectionTitle, color: COLORS.card, letterSpacing: '1px' }}>
            DIFERENCIAIS
          </div>
          <div style={{ fontSize: '9px', opacity: 0.85, letterSpacing: '0.5px', marginTop: '1px' }}>
            QUE VALORIZAM SEU AMBIENTE
          </div>
        </div>
      </div>
      <div style={{ padding: '10px' }}>
        {items.map((adv, i) => (
          <div
            key={i}
            style={{
              display: 'grid',
              gridTemplateColumns: '22px 1fr',
              alignItems: 'center',
              gap: '8px',
              marginBottom: i === items.length - 1 ? 0 : '6px'
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                border: `1.5px solid ${COLORS.primary}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: COLORS.primary
              }}
            >
              <Check size={11} strokeWidth={3} />
            </div>
            <div
              style={{
                borderBottom: `1px solid ${COLORS.line}`,
                fontSize: '11px',
                color: COLORS.textPrimary,
                paddingBottom: '3px',
                minHeight: '16px'
              }}
            >
              {adv}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvantagesCard;
